import { ApiClientImplementation } from 'infra/api-client/api-client'
import { PrepareApiRequestDecorator } from 'main/decorators/prepare-api-request-decorator/prepare-api-request-decorator'
import { makeLocalStorageAdapter } from 'main/factories/cache/local-storage-adapter-factory'
import EligibilityService from 'presentation/contexts/services/eligibility-service'
import { ApiRepository } from 'repository/api-repository'
import { EligibilityRepository } from 'repository/repositories/eligibility/eligibility-repository'
import { RemoteCheckIntegrationOvermind } from 'service/usecases/check-integration-overmind/check-integration-overmind'
import { RemoteCreateConsultEligibility } from 'service/usecases/create-consult-eligibility/create-consult-eligibility'
import { RemoteCreateEligibility } from 'service/usecases/create-eligibility/create-eligibility'
import { RemoteEligibilityCheck } from 'service/usecases/eligibility-check/remote-eligibility-check'
import { RemoteFindConsultsEligibility } from 'service/usecases/find-consults-eligibility/find-consults-eligibility'
import { RemoteUpdateEligibility } from 'service/usecases/update-eligibility-document/remote-update-eligibility-document'

export default function makeEligibilityService() {
  const apiRepository = new PrepareApiRequestDecorator(
    makeLocalStorageAdapter(),
    new ApiRepository(new ApiClientImplementation())
  )

  const eligibilityRepository = new EligibilityRepository(apiRepository)

  const eligibilityCheck = new RemoteEligibilityCheck(eligibilityRepository)

  const checkIntegrationOvermind = new RemoteCheckIntegrationOvermind(
    eligibilityRepository
  )

  const findConsultsEligibility = new RemoteFindConsultsEligibility(
    eligibilityRepository
  )

  const createConsultEligibility = new RemoteCreateConsultEligibility(
    eligibilityRepository
  )

  const updateEligibilityDocument = new RemoteUpdateEligibility(
    eligibilityRepository
  )

  const createEligibility = new RemoteCreateEligibility(eligibilityRepository)

  return new EligibilityService({
    eligibilityCheck,
    checkIntegrationOvermind,
    findConsultsEligibility,
    createConsultEligibility,
    createEligibility,
    updateEligibilityDocument
  })
}
